"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _config = require("@trs/config");
var _icon = _interopRequireDefault(require("../icon"));
var _input = require("../input");
var _button = require("../button");
var _helpers = require("./helpers");
var _StyledTemplatePopup = require("./StyledTemplatePopup.style");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MediaCreator = /*#__PURE__*/function (_Component) {
  function MediaCreator(props) {
    var _this;
    _classCallCheck(this, MediaCreator);
    _this = _callSuper(this, MediaCreator, [props]);
    _defineProperty(_this, "handleMediaTypeChange", function (type) {
      return _this.setState({
        type: type,
        src: '',
        errors: {}
      });
    });
    _defineProperty(_this, "handleMediaUrl", function (e) {
      _this.setState({
        src: e.target.value
      });
    });
    _defineProperty(_this, "handleMediaAltText", function (e) {
      return _this.setState({
        alt: e.target.value
      });
    });
    _defineProperty(_this, "validateData", function () {
      var _this$state = _this.state,
        src = _this$state.src,
        alt = _this$state.alt,
        type = _this$state.type;
      var videoPlatformAccepted = _this.props.videoPlatformAccepted;
      var isVideoPlatform = function isVideoPlatform(video) {
        return videoPlatformAccepted.find(function (platform) {
          return video.includes(platform);
        });
      };
      var urlError = {
        length: src.length > _helpers.MAX_TEXT_LENGTH.URL ? "URL should have a maximum of ".concat(_helpers.MAX_TEXT_LENGTH.URL, " characters.") : null,
        validity: !(0, _helpers.isValidURL)(src) || (0, _helpers.isNotAllowedUrl)(src) || type === _config.MEDIA_TYPE.VIDEO && !isVideoPlatform(src) ? 'Invalid URL' : null
      };
      var altTextError = {
        length: alt.length > _helpers.MAX_TEXT_LENGTH.ALT ? "Text should have a maximum of ".concat(_helpers.MAX_TEXT_LENGTH.ALT, " characters.") : null
      };
      var validUrl = R.isNil(urlError.length) && R.isNil(urlError.validity) && R.isNil(altTextError.length);
      if (R.isEmpty(src)) {
        _this.setState({
          errors: {}
        });
      } else if (!validUrl) {
        _this.setState({
          errors: {
            src: validUrl ? '' : urlError.length || urlError.validity,
            alt: validUrl ? '' : altTextError.length
          }
        });
      }
      return validUrl;
    });
    _defineProperty(_this, "onSave", function () {
      var _this$state2 = _this.state,
        type = _this$state2.type,
        src = _this$state2.src,
        alt = _this$state2.alt;
      var isDataValid = _this.validateData();
      if (isDataValid) {
        _this.props.onChange({
          type: type,
          src: src,
          alt: alt
        });
        _this.props.onClose();
      }
    });
    _this.state = {
      type: props.type,
      src: props.src,
      alt: props.alt,
      errors: {}
    };
    return _this;
  }
  _inherits(MediaCreator, _Component);
  return _createClass(MediaCreator, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        onClose = _this$props.onClose,
        componentName = _this$props.componentName,
        labels = _this$props.labels,
        recommendedMediaSizes = _this$props.recommendedMediaSizes,
        supportedMediaTypes = _this$props.supportedMediaTypes;
      var _this$state3 = this.state,
        type = _this$state3.type,
        src = _this$state3.src,
        alt = _this$state3.alt,
        errors = _this$state3.errors;
      var recommendedSizes = R.isEmpty(recommendedMediaSizes) ? _helpers.RECOMMENDED_SIZE : recommendedMediaSizes;
      return /*#__PURE__*/_react["default"].createElement(_StyledTemplatePopup.StyledMediaCreator, null, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        id: "media-creator-close",
        icon: "ion-close-circled",
        size: 18,
        className: "input-clear-icon",
        "aria-label": "Close pop-up",
        onClick: onClose
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: "popup-title"
      }, labels.EMBED_LINK), /*#__PURE__*/_react["default"].createElement(_StyledTemplatePopup.Tabs, null, Object.keys(supportedMediaTypes).map(function (mediaType) {
        return /*#__PURE__*/_react["default"].createElement(_StyledTemplatePopup.Tab, {
          key: supportedMediaTypes[mediaType],
          className: (0, _classnames["default"])({
            active: supportedMediaTypes[mediaType] === type
          }),
          onClick: function onClick() {
            return _this2.handleMediaTypeChange(supportedMediaTypes[mediaType]);
          }
        }, /*#__PURE__*/_react["default"].createElement("p", null, supportedMediaTypes[mediaType]));
      })), /*#__PURE__*/_react["default"].createElement(_input.InputV2, {
        type: "text",
        placeholder: labels.ENTER_LINK_HERE,
        error: R.prop('src', errors),
        id: "media-url-input",
        value: src,
        onChange: this.handleMediaUrl,
        onFocus: this.validateData
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: "helpertext"
      }, type === _config.MEDIA_TYPE.IMAGE && "".concat(labels.IMAGE_RECOMMENDED_SIZE, ": ").concat(recommendedSizes[componentName].width, " x ").concat(recommendedSizes[componentName].height, " px")), /*#__PURE__*/_react["default"].createElement("p", {
        className: "popup-title"
      }, type === _config.MEDIA_TYPE.IMAGE ? labels.MEDIA_IMAGE_ALT_TEXT : labels.MEDIA_VIDEO_TITLE), /*#__PURE__*/_react["default"].createElement(_input.InputV2, {
        type: "text",
        placeholder: labels.ENTER_TEXT_HERE,
        error: R.prop('alt', errors),
        id: "media-alt-text-input",
        value: alt,
        onChange: this.handleMediaAltText
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "footer"
      }, /*#__PURE__*/_react["default"].createElement(_button.Button, {
        type: "naked",
        medium: true,
        action: onClose,
        className: "media-creator-cancel"
      }, labels.CANCEL_MEDIA_LINK), /*#__PURE__*/_react["default"].createElement(_button.Button, {
        type: "primary",
        medium: true,
        action: this.onSave,
        className: "media-creator-save",
        disabled: R.isEmpty(src)
      }, labels.ADD_MEDIA_LINK)));
    }
  }]);
}(_react.Component);
MediaCreator.defaultProps = {
  type: _config.MEDIA_TYPE.IMAGE,
  src: '',
  alt: '',
  componentName: _helpers.MEDIA_COMPONENTS.MEDIA,
  recommendedMediaSizes: {},
  videoPlatformAccepted: [],
  supportedMediaTypes: _config.MEDIA_TYPE
};
MediaCreator.propTypes = {
  onClose: _propTypes["default"].func.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  type: _propTypes["default"].string,
  src: _propTypes["default"].string,
  alt: _propTypes["default"].string,
  componentName: _propTypes["default"].string,
  supportedMediaTypes: _propTypes["default"].shape({}),
  labels: _propTypes["default"].shape({
    EMBED_LINK: _propTypes["default"].string,
    ADD_MEDIA_LINK: _propTypes["default"].string,
    CANCEL_MEDIA_LINK: _propTypes["default"].string,
    ENTER_TEXT_HERE: _propTypes["default"].string,
    MEDIA_IMAGE_ALT_TEXT: _propTypes["default"].string,
    MEDIA_VIDEO_TITLE: _propTypes["default"].string,
    IMAGE_RECOMMENDED_SIZE: _propTypes["default"].string,
    ENTER_LINK_HERE: _propTypes["default"].string
  }).isRequired,
  recommendedMediaSizes: _propTypes["default"].shape({}),
  videoPlatformAccepted: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
var _default = exports["default"] = MediaCreator;